import './NavbarBrandingImage.scss';

import { selectBrandingImage } from 'redux/selectors/config';
import { useAppSelector } from 'redux/store';

/**
 * The installation's branding image, square and flush to the top-bar's right
 * edge.
 *
 * Renders nothing at all when no image is configured, so the bar is unchanged
 * for an installation that never sets one — an empty `<img>` would show a
 * broken-image glyph instead.
 *
 * Not a link and not a button: it carries whatever the operator put in it, and
 * has no action of its own.
 */
const NavbarBrandingImage = () => {
  const image = useAppSelector(selectBrandingImage);

  if (image === null) return null;

  return <img className="navbar-branding-image" src={image} alt="Branding" />;
};

export default NavbarBrandingImage;
